/* YOKOAMII Anpassungen: Slider-Pfeile Startseite, automatisches Nachladen auf Kategorieseiten, Warenkorb-Zähler */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Slider */
  function update(track) {
    const sec = track.closest('[data-yoko-slider-section]');
    if (!sec) return;
    const max = track.scrollWidth - track.clientWidth - 2;
    sec.querySelectorAll('[data-yoko-slider-step]').forEach(b => {
      const s = Number(b.dataset.yokoSliderStep);
      b.disabled = s < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max;
    });
  }
  function step(track, dir) {
    const card = track.querySelector('.product-card');
    if (!card) return;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const w = card.getBoundingClientRect().width + gap;
    const per = Math.max(1, Math.floor((track.clientWidth + gap) / w + 0.05));
    track.scrollBy({ left: dir * per * w, behavior: reduce ? 'auto' : 'smooth' });
    setTimeout(() => update(track), 450);
    setTimeout(() => update(track), 900);
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-yoko-slider-step]');
    if (!b) return;
    const track = document.getElementById(b.getAttribute('aria-controls'));
    if (track) step(track, Number(b.dataset.yokoSliderStep));
  });
  function initSliders(scope) {
    scope.querySelectorAll('[data-yoko-slider]').forEach(t => {
      if (t.dataset.sliderReady) return;
      t.dataset.sliderReady = '1';
      let f = 0;
      t.addEventListener('scroll', () => { cancelAnimationFrame(f); f = requestAnimationFrame(() => update(t)); }, { passive: true });
      t.addEventListener('scrollend', () => update(t), { passive: true });
      t.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight') { e.preventDefault(); step(t, 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); step(t, -1); }
      });
      if ('ResizeObserver' in window) new ResizeObserver(() => update(t)).observe(t);
      update(t);
    });
  }

  /* Kategorieseiten: beim Scrollen automatisch weitere Produkte laden.
     Der Link bleibt im HTML (fuer Suchmaschinen und als Rueckfall ohne JavaScript). */
  const OFFSET = 900;
  function initInfinite(scope) {
    scope.querySelectorAll('[data-yoko-pagination]').forEach(box => {
      if (box.dataset.infReady) return;
      if (!box.querySelector('[data-yoko-load-more]')) return;
      box.dataset.infReady = '1';
      box.classList.add('is-auto');
      let done = false;
      const near = () => box.getBoundingClientRect().top < window.innerHeight + OFFSET;
      const trigger = () => {
        if (done) return;
        const more = box.querySelector('[data-yoko-load-more]');
        if (!more || more.dataset.busy || !near()) return;
        box.classList.add('is-loading');
        more.click();
      };
      let ticking = false;
      const onScroll = () => { if (ticking) return; ticking = true; setTimeout(() => { ticking = false; trigger(); }, 120); };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      let io = null;
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(entries => { if (entries.some(x => x.isIntersecting)) trigger(); }, { rootMargin: '0px 0px ' + OFFSET + 'px 0px' });
        io.observe(box);
      }
      new MutationObserver(() => {
        box.classList.remove('is-loading');
        if (!box.querySelector('[data-yoko-load-more]')) {
          done = true;
          if (io) io.disconnect();
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
          box.classList.remove('is-auto');
          return;
        }
        setTimeout(trigger, 80);
      }).observe(box, { childList: true });
      trigger();
    });
  }

  /* Warenkorb-Zähler aktuell halten (z. B. nach Zurück-Navigation aus dem Cache) */
  async function refreshCartCount() {
    const els = document.querySelectorAll('[data-cart-count]');
    if (!els.length) return;
    try {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!r.ok) return;
      const c = await r.json();
      els.forEach(el => { el.textContent = c.item_count; el.hidden = false; });
    } catch (e) {}
  }
  window.addEventListener('pageshow', e => { if (e.persisted) refreshCartCount(); });
  document.addEventListener('cart:updated', refreshCartCount);

  function init(scope = document) { initSliders(scope); initInfinite(scope); }
  document.addEventListener('shopify:section:load', e => init(e.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();
